/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/require-default-props */
import React, { useEffect, useRef, useState } from "react";

import ChevronDropDownIcon from "assets/svgs/ChevronDropDownIcon";
import clsx from "clsx";
import FilterIconV2 from "assets/svgs/FilterIconV2";
import FilterIconSelectedV2 from "assets/svgs/FilterIconSelectedV2";
import { isUserLoggedIn } from "utils";
import { useRouter } from "next/router";
import { trackOnMixpanel } from "modules/candidate/profile/utils/MixpanelHelper";
import useJobFeedStore from "components/RevampFeedDetails/JobFeed/store";
import { Chip, ChipContainer, Container, Separator } from "./styles";

type FilterObjType = {
	label: string;
	count: number;
	onClick: () => void;
};

type FiltersidebarPropsType = {
	handleAllFiltersClick: () => void;
	isDesktopView?: boolean;
	filterObj?: FilterObjType[];
	areFiltersPreApplied?: boolean;
	showPreAppliedCoachMark?: boolean;
	departmentObject?: any;
};

const FilterChipsNew: React.FC<FiltersidebarPropsType> = ({
	handleAllFiltersClick,
	isDesktopView,
	filterObj = [],
	areFiltersPreApplied = false,
	showPreAppliedCoachMark = false,
	departmentObject,
}) => {
	const { urlDataObject, discoveryTabs } = useJobFeedStore();
	const [totalFilterCount, setTotalFilterCount] = useState(0);
	const router = useRouter();
	const containerRef = useRef<HTMLDivElement>();
	useEffect(() => {
		let count = 0;
		filterObj.map((obj) => {
			count += obj.count === 0 ? 0 : 1;
			return null;
		});
		setTotalFilterCount(count);
	}, [filterObj]);
	useEffect(() => {
		if (containerRef.current && !router.asPath.includes("#")) {
			containerRef.current.scrollTo({
				left: 0,
				behavior: "smooth",
			});
		}
	}, [router.asPath]);
	const getQueryObj = () => {
		const queryObj: any = {};
		const routerQueries = router.query;
		if (isUserLoggedIn()) {
			queryObj.c_id = isUserLoggedIn();
		}
		if (routerQueries?.city_id) {
			queryObj.city_id = routerQueries?.city_id;
		}
		if (routerQueries?.area_id) {
			queryObj.area_id = routerQueries?.area_id;
		}
		if (routerQueries?.entity_type) {
			queryObj.entity_type = routerQueries?.entity_type;
		}
		if (routerQueries?.entity_id) {
			queryObj.entity_id = routerQueries?.entity_id;
		}
		if (routerQueries?.text) {
			queryObj.text = routerQueries?.text;
		}
		if (routerQueries?.search) {
			queryObj.search = routerQueries?.search;
		}
		if (routerQueries?.location_id) {
			queryObj.location_id = routerQueries?.location_id;
		}
		if (routerQueries?.location_identifier) {
			queryObj.location_identifier = routerQueries?.location_identifier;
		}
		if (routerQueries?.location_type) {
			queryObj.location_type = routerQueries?.location_type;
		}
		if (routerQueries?.location_name) {
			queryObj.location_name = routerQueries?.location_name;
		}

		return queryObj;
	};

	const onClearFiltersClick = () => {
		const queryObj = getQueryObj();
		router.push({
			pathname: isUserLoggedIn() ? "/candidate/jobs" : "/jobs",
			query: queryObj,
		});
	};

	return (
		<ChipContainer
			data-testid="mweb-filter-chips"
			className={clsx("relative flex w-[100%] justify-center", {
				"p-0 py-[16px]": isDesktopView,
				"py-[8px] pl-[12px]": !isDesktopView,
				"!absolute": areFiltersPreApplied && showPreAppliedCoachMark,
				"bg-white": areFiltersPreApplied && showPreAppliedCoachMark,
				"pointer-events-none": areFiltersPreApplied && showPreAppliedCoachMark,
				"border-red border-4 border-solid":
					areFiltersPreApplied && showPreAppliedCoachMark,
			})}
			isDesktopView={isDesktopView && totalFilterCount > 0}
		>
			<Chip
				data-testid="filter-chip-all"
				aria-label={totalFilterCount > 0 ? "active filter" : "inactive filter"}
				key="All Filters"
				selected={false}
				onClick={() => {
					trackOnMixpanel("Job Filter Icon Clicked Web");
					trackOnMixpanel("Job Filter Panel Shown Web", {
						Source: "Filter Icon",
						"Filter Name": "Department",
					});
					handleAllFiltersClick();
				}}
			>
				{totalFilterCount > 0 ? <FilterIconSelectedV2 /> : <FilterIconV2 />}
			</Chip>
			<Container data-testid="filter-chips" id="container" ref={containerRef}>
				{filterObj.map((filter) => {
					if (
						(filter?.label === "Department" &&
							departmentObject[0]?.type === "department" &&
							departmentObject[0]?.id) ||
						(filter?.label === "Gender" && urlDataObject?.path?.gender) ||
						(filter?.label === "Sort by" && discoveryTabs.activeTabId === 2)
					) {
						return <></>;
					}
					return (
						<Chip
							data-testid={`filter-chip-${filter.label}`}
							aria-label={
								filter.count > 0 ? "active filter" : "inactive filter"
							}
							key={filter.label}
							selected={filter.count > 0}
							onClick={() => {
								trackOnMixpanel("Job Filter Chip Click Web", {
									"Filter Clicked": filter.label,
								});
								trackOnMixpanel("Job Filter Panel Shown Web", {
									Source: "Filter Chip",
									"Filter Name": filter.label,
								});
								filter.onClick();
							}}
						>
							<span>{filter.label}</span>
							{filter.count > 0 && (
								<span className="!ml-[4px] flex h-[16px] w-[16px] items-center  justify-center rounded-[12px] bg-[#E8E7EA] text-[10px] font-[600] leading-[8px] text-[#8C8594]">
									{filter.count}
								</span>
							)}
							<ChevronDropDownIcon
								style={{ marginLeft: "4px" }}
								fillColor={filter.count > 0 ? "#ffffff" : "#190A28"}
							/>
						</Chip>
					);
				})}
			</Container>
			{totalFilterCount > 0 && isDesktopView && (
				<div className="ml-[16px] flex shrink-0 items-center">
					<Separator />
					<div
						className="ml-[16px] cursor-pointer py-[8px] text-[14px] font-[600] leading-[20px] text-[#1F8268]"
						onClick={onClearFiltersClick}
					>
						Clear Filters
					</div>
				</div>
			)}
		</ChipContainer>
	);
};

export default FilterChipsNew;
